///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../collections/report-users-non-employees.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportUsersNonEmployeesDataTemplate extends ReportSecureEmployeeDataTemplate implements ISecureDataTemplate {

        protected employees: ReportUsersNonEmployeesCollection;

        public title: string;
        public allSelectedLabel: string;
        public required: boolean;
        public allSelected: boolean;

        get collection() {
            return this.employees;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options);

            this.employees = new ReportUsersNonEmployeesCollection(this.model[properties[0]], [], {
                criteria: { ...options.criteria, includeInactive: true },
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.title = 'LABEL_USERS_TITLE';
            this.allSelectedLabel = 'LABEL_ALL_USERS_CHECKBOX';
            this.totalSelectedMessage = 'LABEL_TOTAL_CREATED_BY_USERS_SELECTED';
            this.filters = [new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_USERS' })];
            this.employees.addFilters(...this.filters as IInteractiveFilter[]);
        }

        setWatchers(scope: angular.IScope) {
            this.employees.setWatchers(scope);
            super.setWatchers(scope);
            this.setValidationWatcher(scope);
        }

        setValidationWatcher(scope: angular.IScope) {
            scope.$watch(() => this.required, (newValue, oldValue) => {
                if (newValue == oldValue) return;

                this.validation = [];
                if (newValue == true) {
                    this.validation.push(
                        new RequiredIfAllUnselectedValidation(
                            this.employees,
                            () => this.smartMoverHidden,
                            'LABEL_REPORTS_SELECT_AT_LEAST_ONE_USER'
                        )
                    );
                }
            });
        }

        onSecurityFail() {
            this.allSelected = false;
            super.onSecurityFail();
        }
    }
}
